<template>
  <v-dialog v-model="dialog" max-width="560" persistent>
    <v-card>
      <v-card-title class="text-h6">Incluir aula complementar</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-select
            v-model="form.classId"
            :items="groupOptions"
            label="Turma"
            :rules="[(v) => !!v || 'Selecione a turma']"
            outlined
            dense
            @change="onGroupChange"
          />

          <v-select
            v-model="form.customerIds"
            :items="studentOptions"
            label="Alunos"
            :rules="[
              (v) => (v && v.length > 0) || 'Selecione ao menos um aluno',
            ]"
            multiple
            chips
            small-chips
            outlined
            dense
            :disabled="!form.classId"
          />

          <v-select
            v-model="selectedSlot"
            :items="slotOptions"
            label="Dia e horario (sua disponibilidade)"
            :rules="[(v) => !!v || 'Selecione um horario']"
            return-object
            outlined
            dense
            no-data-text="Voce nao possui disponibilidade cadastrada"
            @change="onSlotChange"
          />

          <v-select
            v-model="form.level"
            :items="levelOptions"
            label="Nivel"
            :rules="[(v) => v !== null || 'Selecione o nivel']"
            :disabled="!form.classId"
            outlined
            dense
            @change="loadSubjects"
          />

          <v-select
            v-model="form.courseClassId"
            :items="subjectOptions"
            label="Assunto"
            :rules="[(v) => !!v || 'Selecione o assunto']"
            :loading="loadingSubjects"
            :disabled="form.level === null || loadingSubjects"
            no-data-text="Nenhum assunto disponivel para o nivel selecionado"
            outlined
            dense
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" :disabled="saving" @click="close">
          Cancelar
        </v-btn>
        <v-btn color="primary" :loading="saving" @click="submit">
          Incluir aula
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import partnerApi from "@/shared/pitchPartnerApi";
import { ENGLISH_LEVELS } from "@/shared/classPresentation";

const WEEK_DAYS = [
  "Domingo",
  "Segunda",
  "Terca",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sabado",
];

export default {
  name: "IncluirAulaDialog",
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    availability: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      saving: false,
      loadingSubjects: false,
      subjects: [],
      selectedSlot: null,
      form: {
        classId: null,
        customerIds: [],
        weekDay: null,
        startHour: null,
        endHour: null,
        courseClassId: null,
        level: null,
      },
    };
  },
  computed: {
    groupOptions() {
      return this.groups.map((group) => ({
        text: `Turma ${group.cod}`,
        value: group.id,
      }));
    },
    selectedGroup() {
      return (
        this.groups.find((group) => group.id === this.form.classId) || null
      );
    },
    studentOptions() {
      if (!this.selectedGroup) return [];
      return (this.selectedGroup.content || []).map((student) => ({
        text: student.name,
        value: student.id,
      }));
    },
    slotOptions() {
      return this.availability.map((slot) => ({
        text: `${WEEK_DAYS[slot.weekDay]} - ${slot.from} as ${slot.to}`,
        value: `${slot.weekDay}-${slot.from}-${slot.to}`,
        weekDay: slot.weekDay,
        from: slot.from,
        to: slot.to,
      }));
    },
    subjectOptions() {
      return this.subjects.map((subject) => ({
        text: subject.title,
        value: subject.id,
      }));
    },
    levelOptions() {
      return ENGLISH_LEVELS;
    },
  },
  methods: {
    open() {
      this.reset();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    reset() {
      this.selectedSlot = null;
      this.subjects = [];
      this.form = {
        classId: null,
        customerIds: [],
        weekDay: null,
        startHour: null,
        endHour: null,
        courseClassId: null,
        level: null,
      };
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    onGroupChange() {
      this.form.customerIds = [];
      this.form.courseClassId = null;
      this.form.level = this.selectedGroup ? this.selectedGroup.level : null;
      this.loadSubjects();
    },
    onSlotChange(slot) {
      if (!slot) return;
      this.form.weekDay = slot.weekDay;
      this.form.startHour = slot.from;
      this.form.endHour = slot.to;
    },
    loadSubjects() {
      this.form.courseClassId = null;
      if (this.form.level === null || this.form.level === undefined) {
        this.subjects = [];
        return;
      }
      this.loadingSubjects = true;
      partnerApi
        .getClassContentByLevel(this.form.level)
        .then((res) => {
          this.subjects = res.data.content || [];
        })
        .catch(() => {
          this.subjects = [];
        })
        .finally(() => {
          this.loadingSubjects = false;
        });
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      partnerApi
        .createComplementaryClass({
          classId: this.form.classId,
          customerIds: this.form.customerIds,
          weekDay: Number(this.form.weekDay),
          startHour: this.form.startHour,
          endHour: this.form.endHour,
          courseClassId: this.form.courseClassId,
        })
        .then(() => {
          this.$root.$emit("display-alert", {
            text: "Aula complementar criada com sucesso!",
            type: 0,
          });
          this.dialog = false;
          this.$emit("created");
        })
        .catch((error) => {
          const text =
            error?.response?.data?.message ||
            "Nao foi possivel criar a aula complementar.";
          this.$root.$emit("display-alert", { text, type: 1 });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
